import { useEffect, useState } from 'react'
import { Carousel, CarouselControl, CarouselItem } from 'reactstrap'
import { TemplatePhoto } from '../types'
import styles from './ImageCarousel.module.css'

interface ImageCarouselProps {
    photos: TemplatePhoto[]
    changePhoto: (event: React.MouseEvent<HTMLImageElement>) => void
}

const ImageCarousel = (props: ImageCarouselProps) => {
    const { photos, changePhoto } = props

    const [activeIndex, setActiveIndex] = useState(0)
    const itemsPerSlide = photos.length <= 3 ? photos.length : 3

    const photosToDisplay = photos?.slice(activeIndex, activeIndex + itemsPerSlide)

    useEffect(() => {
        setActiveIndex(0)
    }, [photos])

    const next = () => {
        setActiveIndex((currentIndex) => {
            const nextIndex = currentIndex + 1

            if (currentIndex + itemsPerSlide === photos.length) return currentIndex
            return nextIndex
        })
    }

    const previous = () => {
        setActiveIndex((currentIndex) => {
            const prevIndex = currentIndex - 1

            if (currentIndex === 0) return currentIndex
            return prevIndex
        })
    }

    return (
        <Carousel
            activeIndex={activeIndex}
            next={next}
            previous={previous}
            ride="carousel"
            slide={false}
            interval={false}
            className={styles.imageCarousel}
        >
            {/* <CarouselIndicators items={photos} /> */}

            {photosToDisplay.map((photo, index) => (
                <CarouselItem key={index} className={styles.imageItem}>
                    <img onClick={changePhoto} src={photo.src} id={photo.id.toString()} alt={photo.id.toString()} />
                </CarouselItem>
            ))}

            <CarouselControl direction="prev" onClickHandler={previous} />
            <CarouselControl direction="next" onClickHandler={next} />
        </Carousel>
    )
}

export default ImageCarousel
